<div class="rounded px-2 my-4 py-2 flex flex-col align-center" [ngClass]="{
        'bg-green/15': isCorrect && isHit,
        'bg-red/15': !isCorrect && !isHit,
        'bg-background-dark': isCorrect && !isHit
    }">
    <label class="inline-flex items-center w-full">
        @if(correctCount == 1){
        @if(isCorrect && isHit){
        <ng-icon class="text-green shrink-0" size="1.5rem" name="faSolidCircleCheck" />
        } @else if (isCorrect && !isHit) {
        <ng-icon class="text-green shrink-0" size="1.5rem" name="faCircleCheck" />
        }
        @else if (!isCorrect && !isHit) {
        <ng-icon class="text-red shrink-0" size="1.5rem" name="faSolidCircleXmark" />
        } @else {
        <input class="form-radio h-6 w-6" type="radio" name="answer_option" disabled [value]="id" [id]="id" />
        }
        } @else {
        @if(isCorrect && isHit){
        <ng-icon class="text-green shrink-0" size="1.5rem" name="faSolidSquareCheck" />
        } @else if (isCorrect && !isHit) {
        <ng-icon class="text-green shrink-0" size="1.5rem" name="faSquareCheck" />
        }
        @else if (!isCorrect && !isHit) {
        <ng-icon class="text-red shrink-0" size="1.5rem" name="faSolidSquareXmark" />
        } @else {
        <input class="form-checkbox rounded-md h-6 w-6" type="checkbox" name="answer_option" disabled [value]="id"
            [id]="id" /> }
        }
        <span class="ml-2">{{ index }}. {{ value }}</span>
    </label>
</div>